/**
 * Origin helpers for Google Auth error copy.
 *
 * Rhythmé does not maintain its own Google-origin allowlist. Firebase Auth
 * and Google OAuth do. These helpers only distinguish localhost (supported
 * for development) from private LAN IPs (not a supported Google OAuth origin)
 * so the user-facing message can be accurate.
 */

export function hostnameOf(originOrHost) {
  if (!originOrHost || typeof originOrHost !== 'string') return '';
  try {
    if (originOrHost.includes('://')) return new URL(originOrHost).hostname;
  } catch {
    return '';
  }
  return originOrHost;
}

/**
 * RFC1918 / loopback / IPv6 unique-local detection.
 * Loopback is NOT treated as a LAN origin: Google and Firebase special-case it.
 */
export function isLoopbackHostname(hostname) {
  const host = String(hostname || '').replace(/^\[|\]$/g, '').toLowerCase();
  return host === 'localhost'
    || host.endsWith('.localhost')
    || host === '127.0.0.1'
    || host === '::1'
    || host === '0:0:0:0:0:0:0:1';
}

export function isPrivateLanHostname(hostname) {
  const host = String(hostname || '').replace(/^\[|\]$/g, '').toLowerCase();
  if (!host || isLoopbackHostname(host)) return false;
  if (/^10(?:\.\d{1,3}){3}$/.test(host)) return true;
  if (/^192\.168(?:\.\d{1,3}){2}$/.test(host)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2}$/.test(host)) return true;
  if (host.includes(':') && (host.startsWith('fc') || host.startsWith('fd'))) return true;
  return false;
}

export function isPrivateLanOrigin(origin) {
  try {
    const url = new URL(origin);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    return isPrivateLanHostname(url.hostname);
  } catch {
    return false;
  }
}

export const LAN_GOOGLE_AUTH_MESSAGE = 'Google sign-in isn’t available from this local network address. You can keep using Rhythmé as a guest. To connect Google, open the app on this computer at localhost, or use a deployed HTTPS origin.';
